import React from "react";
import { Link, Breadcrumbs, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";

const useStyles = (theme, isMobile) => ({
  breadcrumbs: {
    ml: { md: "10%", lg: "15%" },
    marginTop: "21px",
    marginBottom: "21px",
    width: "100%",
    display: "flex",
    justifyContent: isMobile ? "center" : "flex-start",
    alignItems: "center",
    "& ol": {
      justifyContent: isMobile ? "center" : "flex-start",
    },
  },
  typography: {
    link: {
      color: "#868686",
      fontFamily: theme.typography.montserrat.regular,
      fontSize: "16px",
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
});

const BreadCrumbs = ({ breadcrumbs }) => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const { first, second, third } = breadcrumbs;

  return (
    <Breadcrumbs separator="|" sx={classes.breadcrumbs}>
      {first && first.text ? (
        <Link href={first.link} underline="hover" sx={classes.typography.link}>
          {first && first.text}
        </Link>
      ) : null}
      {second && second.text ? (
        <Link underline="hover" sx={classes.typography.link}>
          {second && second.text}
        </Link>
      ) : null}
      {third && third.text ? (
        <Link underline="hover" sx={classes.typography.link}>
          <b> {third && third.text}</b>
        </Link>
      ) : null}
    </Breadcrumbs>
  );
};

export default BreadCrumbs;
